import { FC, useMemo, } from "react";
import classnames from 'classnames';
import { LayOutPageLeftPageProps, LayOutPageItemEnum, } from "../interface";

const LayOutPageLeftPage: FC<LayOutPageLeftPageProps> = props => {
  const { className, headerClassName, headerStyle, title, afterNode, bodyClassName, bodyStyle, bodyNode, ...restProps } = props;
  const classes = useMemo(() => {
    return classnames('yb-layout-page-lefts-item', className);
  }, [className]);
  const headerClasses = useMemo(() => {
    return classnames('item-header', headerClassName);
  }, [headerClassName]);
  const bodyClasses = useMemo(() => {
    return classnames('item-body', bodyClassName);
  }, [bodyClassName]);
  return (
    <div className={classes} {...restProps}>
      <div className={headerClasses} style={headerStyle}>
        <span>{title}</span>
        {afterNode}
      </div>
      <div className={bodyClasses} style={bodyStyle}>
        {bodyNode}
      </div>
    </div>
  );
};

LayOutPageLeftPage.displayName = LayOutPageItemEnum.LeftPage;

export default LayOutPageLeftPage;